import logo1 from "../../../assets/images/logos/logo_llbean.jpg";
import logo2 from "../../../assets/images/logos/logo_si.jpg";
import logo3 from "../../../assets/images/logos/logo_nanoinstitute.jpg";
import logo4 from "../../../assets/images/logos/logo_disneychannel.jpg";
import logo5 from "../../../assets/images/logos/logo_caa.jpg";
import logo6 from "../../../assets/images/logos/logo_google.jpg";
import logo7 from "../../../assets/images/logos/logo_geneone.jpg";
import logo8 from "../../../assets/images/logos/logo_oculus.jpg";
import logo9 from "../../../assets/images/logos/logo_condenast.jpg";
import logo10 from "../../../assets/images/logos/logo_whitehouse.jpg";
import logo11 from "../../../assets/images/logos/logo_npr.jpg";
import logo12 from "../../../assets/images/logos/logo_christies.jpg";
import logo13 from "../../../assets/images/logos/logo_nyt.jpg";
import logo14 from "../../../assets/images/logos/logo_deloitte.jpg";
import logo15 from "../../../assets/images/logos/logo_justins.jpg";
import logo16 from "../../../assets/images/logos/logo_vanguard.jpg";
import logo17 from "../../../assets/images/logos/logo_ge.jpg";
import logo18 from "../../../assets/images/logos/logo_usnews.jpg";
import logo19 from "../../../assets/images/logos/logo_phillies.jpg";
import logo20 from "../../../assets/images/logos/logo_b.jpg";
import logo21 from "../../../assets/images/logos/logo_cdc.jpg";
import logo22 from "../../../assets/images/logos/logo_espn.jpg";
import logo23 from "../../../assets/images/logos/logo_pga.jpg";
import logo24 from "../../../assets/images/logos/logo_peacecorps.jpg";

const logos = [
  { image: logo1, title: "L.L. Bean" },
  { image: logo2, title: "The Smithsonian Institute" },
  { image: logo3, title: "Nano Institute" },
  { image: logo4, title: "The Disney Channel" },
  { image: logo5, title: "CAA" },
  { image: logo6, title: "Google" },
  { image: logo7, title: "Gene One" },
  { image: logo8, title: "Oculus" },
  { image: logo9, title: "Condé Nast" },
  { image: logo10, title: "The White House" },
  { image: logo11, title: "NPR" },
  { image: logo12, title: "Christie's" },
  { image: logo13, title: "The New York Timess" },
  { image: logo14, title: "Deloitte" },
  { image: logo15, title: "Justin's" },
  { image: logo16, title: "Vanguard" },
  { image: logo17, title: "GE" },
  { image: logo18, title: "U.S. News" },
  { image: logo19, title: "Phillies" },
  { image: logo20, title: "Barclay's" },
  { image: logo21, title: "CDC" },
  { image: logo22, title: "ESPN" },
  { image: logo23, title: "PGA Tour" },
  { image: logo24, title: "United States Peace Corps" },
];

export default logos;
